import { PreguntaCargaDTO } from "@DTOS";
import { PreguntasTipoEnum, SingleSubtipoEnum } from "@shared/enums";
import { DatosPreguntaImportador } from "../DatosPreguntaImportador";
import { PREGUNTA_PADRE } from "../constantesImportador";
import { PreguntaImportador } from "../PreguntaImportador";

export class PreguntaItemMatchImportador extends PreguntaImportador {
    public puedeProcesar(tipoPregunta: PreguntasTipoEnum): boolean {
        return tipoPregunta === PreguntasTipoEnum.ITEM_MATCH;
    }

    public testear(datos: DatosPreguntaImportador[], esUltima: boolean = false): boolean {
        let pasoTests = super.testear(datos, esUltima);
        const preguntaPadre = datos[PREGUNTA_PADRE];
        const hayUnKiller = datos.slice(1).filter(item =>
            item.tipoOpcion === "K" || (item.killer != null && item.killer)
        ).length === 1;
        if (!hayUnKiller) {
            pasoTests = false;
            this.errores.push(`La pregunta ${preguntaPadre.idPregunta} debe contener un solo item Killer`);
        }
        return pasoTests;
    }

    public procesar(datos: DatosPreguntaImportador[]): PreguntaCargaDTO[] {
        const preguntas = super.procesar(datos);
        const preguntaPadre = preguntas[PREGUNTA_PADRE];
        preguntaPadre.tipo = PreguntasTipoEnum.SINGLE_CHOICE;
        preguntaPadre.subtipo = SingleSubtipoEnum.SINGLE_TEXT;
        return preguntas;
    }
}
